import { Modal } from "antd";
import React, { useState } from "react";
import foreignRequest from "../../foreignRequest";
import { ModalStatusDelete } from "../../../../../Utils/modalStatus";

export const ModalDelete = ({ visible, onCancel, id, onDelete }) => {
  const [loading, setLoading] = useState(false);
  const [openModalStatus, setOpenModalStatus] = useState(false);

  const deletarForeign = async () => {
    setLoading(true);
    try {
      const response = await foreignRequest.deleteForeign(id);
      if (response.status === 204) {
        onCancel();
        onDelete((prevState) => {
          return prevState.filter((foreignValue) => {
            return foreignValue.id !== id;
          });
        });
        setOpenModalStatus(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal
        visible={visible}
        onCancel={onCancel}
        onOk={deletarForeign}
        confirmLoading={loading}
      >
        <text style={{ fontWeight: "500", fontSize: 16 }}>
          Deseja deletar essa Foreign Key?
        </text>
      </Modal>

      <ModalStatusDelete
        onCancel={() => setOpenModalStatus(false)}
        visible={openModalStatus}
      />
    </>
  );
};
